import Svg, { Path, type SvgProps } from 'react-native-svg'

export function Like(props: SvgProps) {
  return (
    <Svg width="33" height="32" viewBox="0 0 33 32" fill="none" {...props}>
      <Path
        d="M9.8335 13.3335V29.3335"
        stroke="black"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.4998 7.83984L19.1665 13.3332H26.9398C27.3538 13.3332 27.7621 13.4296 28.1324 13.6147C28.5027 13.7998 28.8248 14.0686 29.0732 14.3998C29.3216 14.731 29.4894 15.1155 29.5635 15.5228C29.6375 15.9301 29.6158 16.3491 29.4998 16.7465L26.3932 27.4132C26.2316 27.9671 25.8948 28.4536 25.4332 28.7998C24.9716 29.146 24.4102 29.3332 23.8332 29.3332H5.83317C5.12593 29.3332 4.44765 29.0522 3.94755 28.5521C3.44746 28.052 3.1665 27.3737 3.1665 26.6665V15.9998C3.1665 15.2926 3.44746 14.6143 3.94755 14.1142C4.44765 13.6141 5.12593 13.3332 5.83317 13.3332H9.51317C10.0093 13.3329 10.4955 13.1943 10.9171 12.9328C11.3387 12.6713 11.6791 12.2975 11.8998 11.8532L16.4998 2.6665C17.1286 2.67429 17.7475 2.82406 18.3102 3.10463C18.873 3.3852 19.3651 3.78931 19.7497 4.28677C20.1343 4.78424 20.4016 5.36218 20.5315 5.97744C20.6614 6.5927 20.6506 7.22935 20.4998 7.83984Z"
        stroke="black"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
